export default "__VITE_ASSET__Dpx8PZ_J__"